<script lang="ts">
    export let title: string;
</script>
<div class="box-l sx-ii">
    <div class="back box-l pr-iii py-i pointer" on:click>
        <div>
            <img height="20" width="20" style="transform: rotate(180deg)"
                 src="/static/storefront/pix/icons/chevron-red.svg">
        </div>
    </div>
    <strong>{title}</strong>
</div>
<style>
    .back {
        display: block;
        border-right: 1px solid var(--bg-gray);
        cursor: pointer;
    }
</style>